<template>
  <v-layout column class="pr-5">
    <v-flex class="pb-16 pr-5">
      <text-field
        v-model.trim="form.title"
        autofocus
        :disabled="disabled"
        :validator="vs.form.title"
        :label="adminText('workflowsAll.announcement_title_d5521a2', 'Announcement title')"
      />
    </v-flex>
    <v-flex class="pb-16 pr-5">
      <textarea-field
        v-model.trim="form.text"
        :disabled="disabled"
        :validator="vs.form.text"
        :label="adminText('workflowsAll.announcement_text_0179106', 'Announcement text')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <switch-field
        v-model="form.isPushNotification"
        :disabled="disabled"
        :validator="vs.form.isPushNotification"
        :label="adminText('workflowsAll.send_notification_6140a68', 'Send notification')"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'

export default {
  mixins: [WorkflowDisplay],
  name: 'announcement-form',
  props: {
    initialValues: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data(){
    return {
      form: this.initialValues || { form: {}},
    }
  },
  watch: {
    form: {
      handler(val){
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>

</style>
